import { AdjustedLine, ModifierContext } from "./modifier-models";

// ===== rule-base.ts ==========================================================
export interface Rule {
    name: string;
    /** true  = mutate line immediately
     false = push a suggestion instead           */
    run(line: AdjustedLine,
        ctx: ModifierContext,
        autoApply: boolean): void;
    /** apply the rule to a list of lines */
    apply(
        lines: AdjustedLine[],
        ctx: ModifierContext,
        warn: string[]
    ): AdjustedLine[];
}

export abstract class BaseRule implements Rule {
    abstract name: string;
    abstract run(line: AdjustedLine, ctx: ModifierContext, autoApply: boolean): void;
    abstract apply(
        lines: AdjustedLine[],
        ctx: ModifierContext,
        warn: string[]
    ): AdjustedLine[];
    protected clone<T>(arr: T[]): T[] {
        return arr.map(v => ({ ...v }));
    }
}